<template>
    <information-popup modal-id="inscriptionExamplesPopup">
        <template slot="header">Inscription Examples</template>
        <slot>
            <div class="modal-body inscription-modal">
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">ANNIVERSARY</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>CELEBRATING OUR</p>
                        <p>5TH ANNIVERSARY</p>
                        <p>JILL &amp; TOM CABE</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>PROSPER FOREVER</p>
                        <p>IN OUR HEARTS</p>
                        <p>TONY &amp; NINA PARK</p>
                        <p>MET AT PROSPER</p>
                        <p>IN 1997, MARRIED</p>
                        <p>IN 2010</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>OUR JOURNEY</p>
                        <p>BEGAN AT</p>
                        <p>PROSPER</p>
                        <p>GO EAGLES!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">GRADUATION</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>EMMA DAVIS</p>
                        <p>CLASS OF 2014</p>
                        <p>EAGLE FOR LIFE!</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>TO OUR DAUGHTER</p>
                        <p>EMILY BROWN</p>
                        <p>CONGRATULATIONS</p>
                        <p>ON YOUR</p>
                        <p>GRADUATION</p>
                        <p>LOVE, MOM &amp; DAD</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>JEFFREY DAVIS</p>
                        <p>WE ALWAYS</p>
                        <p>BELIEVED IN YOU</p>
                        <p>AND ARE SO PROUD</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">STUDENT ATHLETES</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>ERIC HARPER</p>
                        <p>TIGHT END</p>
                        <p>1997 - 2001</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>THANK YOU</p>
                        <p>PROSPER ISD</p>
                        <p>FOR THE HONOR</p>
                        <p>OF COMPETING &amp;</p>
                        <p>AN EDUCATION</p>
                        <p>THOMAS FERRY</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>FOREVER GRATEFUL</p>
                        <p>FOR THE CHANCE</p>
                        <p>TO PLAY FOR</p>
                        <p>EAGLE VOLLEYBALL</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FAMILY</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>PROSPER FAMILY</p>
                        <p>LISA, TOM &amp;</p>
                        <p>THE PIPER KIDS</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>1 BIG EAGLE</p>
                        <p>FAMILY</p>
                        <p>MIKE &amp; JILL - 1979</p>
                        <p>SHAWN - 2012</p>
                        <p>JESSICA - 2018</p>
                        <p>THE HAMER FAMILY</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>WE LOVE THE</p>
                        <p>EAGLES!</p>
                        <p>BRENDA, JANE</p>
                        <p>THAD &amp; JOEY</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FATHER'S DAY</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>DANNY PERRATTA</p>
                        <p>NUMBER ONE FAN!</p>
                        <p>NUMBER ONE DAD!</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>THE MOST HOPEFUL</p>
                        <p>EAGLE FAN.</p>
                        <p>ALWAYS THERE TO</p>
                        <p>SUPPORT PROSPER!</p>
                        <p>WE LOVE YOU DAD!</p>
                        <p>JOSH &amp; ANNA</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>IN HONOR OF</p>
                        <p>THE BEST FATHER</p>
                        <p>&amp; THE ULTIMATE</p>
                        <p>EAGLE FAN!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">MOTHER'S DAY</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>#1 MOTHER</p>
                        <p>MY LOVE ALWAYS</p>
                        <p>BETHANY MARSH</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>MARY WATERS</p>
                        <p>THE MOM WHO</p>
                        <p>GAVE HER LOVE</p>
                        <p>&amp; SUPPORT SO I</p>
                        <p>COULD SUCCEED!</p>
                        <p>LOVE, AMANDA</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>MEG MARSHALL</p>
                        <p>LOVES HER SONS</p>
                        <p>&amp; WE LOVE YOU!</p>
                        <p>PARKER &amp; COLE</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">GENERAL</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>EAGLE ALUMNI</p>
                        <p>REESE DeMARC</p>
                        <p>-2015-</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>ERIC &amp; JENNY</p>
                        <p>THOMPSON</p>
                        <p>EVERY HOME GAME</p>
                        <p>SINCE 1991</p>
                        <p>WE LOVE OUR</p>
                        <p>PROSPER FAMILY!</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>OUR STORY IS A</p>
                        <p>GOOD ONE, ALL</p>
                        <p>OUR MEMORIES</p>
                        <p>STRONG &amp; TRUE!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">INSPIRING</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>PROSPER ALWAYS</p>
                        <p>HOLDS OUR HEARTS</p>
                        <p>BRAXTON FAMILY</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>AMBER &amp; LAUREN</p>
                        <p>SO PROUD OF OUR</p>
                        <p>GIRLS FOR BEING</p>
                        <p>FIRST EAGLES</p>
                        <p>IN THE FAMILY</p>
                        <p>LOVE, MOM &amp; DAD</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>PROSPER</p>
                        <p>TRADITIONS</p>
                        <p>BRING FAMILIES</p>
                        <p>TOGETHER!</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">REMEMBRANCE</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>IN HONOR OF</p>
                        <p>BRETT DUNN</p>
                        <p>1994 - 2013</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>HONORING</p>
                        <p>GRANDPA GENE</p>
                        <p>PROSPER ALUM '59</p>
                        <p>AND PROUD FAN</p>
                        <p>THANKS FOR ALL</p>
                        <p>THE MEMORIES!</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>IN MEMORY OF</p>
                        <p>MICHAEL HADLEY</p>
                        <p>LOST BUT NOT</p>
                        <p>FORGOTTEN!</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">TEAM</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>TRUE EAGLES</p>
                        <p>NEVER QUIT!</p>
                        <p>PROSPER FOREVER!</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>WHETHER IN THE</p>
                        <p>SUNSHINE, RAIN,</p>
                        <p>OR SNOW,</p>
                        <p>WE'LL BE HERE</p>
                        <p>FOR THE EAGLES!</p>
                        <p>THE ANDERSONS</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>GO EAGLES!</p>
                        <p>WE ARE AT EVERY</p>
                        <p>FOOTBALL GAME!</p>
                        <p>YOUR LOYAL FANS</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">HOLIDAY</h3>
                        <p><strong>4x8 BRICK</strong></p>
                        <p>MERRY CHRISTMAS</p>
                        <p>#1 EAGLE &amp; #1</p>
                        <p>SON: SETH MILLS</p>
                        <br/>
                        <p><strong>8x8 BRICK</strong></p>
                        <p>GOING TO GAMES</p>
                        <p>TOGETHER WAS</p>
                        <p>THE BEST GIFT</p>
                        <p>OF ALL!</p>
                        <p>WE LOVE YOU,</p>
                        <p>GRANDPA SAM!</p>
                        <br/>
                        <p><strong>8x8 LOGO BRICK</strong></p>
                        <p>NOW I'LL ALWAYS</p>
                        <p>BE HOME FOR THE</p>
                        <p>HOLIDAYS AT</p>
                        <p>PISD STADIUM</p>
                    </div>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-examples',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style lang="scss" scoped>
    .inscription-modal {
        h3,
        p {
            white-space: nowrap;
        }
    }
</style>



// WEBPACK FOOTER //
// InscriptionExamples.vue?d907960c